import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "size-guide-accordion" }
const _hoisted_2 = { class: "size-guide-accordion__title" }

import { computed, markRaw } from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';

import ProductDetailsAccordionSize from '../ProductDetailsAccordion/ProductDetailsAccordionSize.vue';
import ProductDetailsAccordionFit from '../ProductDetailsAccordion/ProductDetailsAccordionFit.vue';
import Accordion, { AccordionItem } from '@/components/Accordion/Accordion.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SizeGuideAccordion',
  setup(__props) {

const { websiteText } = useWebsiteTexts();

const rawComponents = {
  size: markRaw(ProductDetailsAccordionSize),
  fit: markRaw(ProductDetailsAccordionFit),
};

const items = computed<AccordionItem[]>(() => [getSizeItem(), getFitItem()]);

function createAccordionItem(config: Partial<AccordionItem>) {
  return {
    title: config.title || '',
    content: config.content || null,
    component: config.component || {},
  };
}

function getSizeItem() {
  const title = websiteText('sizeguide__title').value || 'Size Guide';
  return createAccordionItem({
    title: title,
    component: rawComponents.size,
  });
}

function getFitItem() {
  const title = websiteText('productdetails_fittab').value || 'Fit';
  return createAccordionItem({
    title: title,
    component: rawComponents.fit,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(websiteText)('addtocart__size_info').value), 1),
    _createVNode(Accordion, {
      items: _unref(items),
      singleExpand: true
    }, null, 8, ["items"])
  ]))
}
}

})